(function () {
    try {
        var a = [" MMMMMMMMMMM      MMMMMMMMM \n", "  MMMMMMMMMMM    MMMMMMMMMM \n", "   MMMMMMMMMM   MMMMMMMMMM  \n", "   MMMMMMMMMM  MMMMMMMMMMM  \n", "  MMMMMMMMMMMMMMMMMMMMMMM   Monmouth University #FlyHawks\n", "  MMMMMMMMMMMMMMMMMMMMMMM   \n", " MMMMMM  MMMMMMMM  MMMMM    \n", " MMMMMM  MMMMMMM  MMMMMM    \n", "MMMMMM   MMMMMM  MMMMMM     \n"].join("").split("");
        //for (a.reverse(); b--;) c.push("%c" + a[b]), "M" === a[b] ? d.push("color: #002588") : d.push("");
        //console.log.apply(console, [c.join("")].concat(d))
        console.log(a.join(""));
    } catch (e) {}
}());

(function (d, active, breakpoint) {
    "use strict";

    // helper functions to toggle a class name on an element
    function removeClass(el, classname) {
        if (typeof el === 'undefined') return;
        el.className = el.className.replace(" " + classname, "");
    }

    function addClass(el, classname) {
        el.className += " " + classname;
    }

    function hasClass(el, classname) {
        return ((" " + el.className + " ").replace(/[\t\r\n]/g, " ").indexOf(" " + classname + " ") >= 0);
    }

    function noClass(el, classname) {
        return ((" " + el.className + " ").replace(/[\t\r\n]/g, " ").indexOf(" " + classname + " ") < 0);
    }

    function toggleClass(el, classname) {
        if (hasClass(el, classname)) {
            removeClass(el, classname);
        } else {
            addClass(el, classname);
        }
    }

    function isElementInViewport(el) {
        var rect = el.getBoundingClientRect();
        var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        var windowWidth = (window.innerWidth || document.documentElement.clientWidth);
        var vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
        var horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);
        return (vertInView && horInView);
    }

    function findAncestor(el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    }

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    function is_ieedge() {
        var rv = false; // Return value assumes failure.

        if (/MSIE 10/i.test(navigator.userAgent)) {
            // This is internet explorer 10
            rv = 10;
        }
        if (/MSIE 9/i.test(navigator.userAgent)) {
            rv = 9;
        }
        if (/rv:11.0/i.test(navigator.userAgent)) {
            rv = 11;
        }
        if (/Edge\/\d./i.test(navigator.userAgent)) {
            rv = 'edge';
        }
        return rv;
    }

    function injectscript(url, callback) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        if (script.readyState) { //IE
            script.onreadystatechange = function () {
                if (script.readyState === "loaded" || script.readyState === "complete") {
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else { //Others
            script.onload = callback;
        }
        script.src = url;

        var firstscript = document.getElementsByTagName('script')[0];
        firstscript.parentNode.insertBefore(script, firstscript);
    }

    // Change the Focus to the main body area when the Skip nav is used.
    var skipnav = d.getElementById("skipnav");
    if (skipnav) {
        skipnav.onclick = function () {
            var content = d.getElementById("content");
            content.focus();
        };
    }

    //toggle the Grey top Nav
    var greymenuButton = d.getElementById("toggleGreyNav");
    var greymenu = d.getElementById("greynav");
    var greymenustyle = document.createElement('style');
        document.body.appendChild(greymenustyle);
    var topNav = d.getElementById("topNav");
    var bluebar = d.getElementById("blueHeader");
    var adminbar = hasClass(d.body, 'admin-bar');

    if (greymenu && topNav) {
        
        calculateGreyOffset();

        //attach to the button to show / hide the menu after it has scrolled past view.
        greymenuButton.onclick = function () {
            toggleClass(greymenu, active);
            toggleClass(greymenuButton, active);
            toggleClass(d.body, 'greymenuactive');
            greymenustyle.innerHTML+= '@supports (position: sticky) {.grey-nav.active{top:' + bluebar.getBoundingClientRect().bottom  + 'px;}}';

        };

        // give the subnav carets click events
        activateCarets();
    }

    // caculate the offset we will need for the grey menu when it is inactive and active. 
    function calculateGreyOffset(){
        if (greymenu && topNav) {
            var style = '';
            // for phones we are trying to line up the bottom of the grey bar with the bottom of the grey menu
            //  0 - height of grey nav + the bottom position of the header when collapsed + the height of the blue bar.             
            
            style+= '.grey-nav{top:' + ( 0 - greymenu.getBoundingClientRect().height + 60 + bluebar.getBoundingClientRect().height ) + 'px;}';

            // for larger screens. 
            var greymenuinitialoffset = parseInt( window.getComputedStyle(bluebar, null).top ) - (greymenu.offsetHeight - bluebar.offsetHeight);
            
            style+= '@media(min-width: 786px){';
                style+= '.grey-nav{top: ' + greymenuinitialoffset + 'px;}';
                // style+= '.grey-nav.active{top:' + (greymenuinitialoffset + greymenu.offsetHeight) + 'px;}';
            style+='}';

            greymenustyle.innerHTML = '@supports (position: sticky) { ' + style + ' }';
    
        }
    }

    // give subnav carets ability to display subnav items on click
    function activateCarets() {
        // if there are no subnav carets, cut the cord
        var subNavActivators = document.querySelectorAll('.subNavActivator');
        if (subNavActivators.length == 0) {
            return;
        }

        // run through each subnav caret
        // (note: subNavActivator is a span tag hovering over the svg)
        for (var i = 0; i < subNavActivators.length; i++) {
            var curEl = subNavActivators[i];
            curEl.onclick = function (e) {
                // toggle parent menu-item's active class and current submenu's max-height
                // whenever the user clicks the activator. This will display/hide the sub-nav items
                var parent = findAncestor(e.target, 'menu-item');
                var grandparent = findAncestor(parent, 'menu-item');
                var submenu = parent.querySelectorAll('.sub-menu')[0];
                var subsubmenu = grandparent ? grandparent.querySelectorAll('.sub-menu')[0] : null;
                if (!hasClass(parent, 'active')) {
                    addClass(parent, 'active');
                    submenu.style.maxHeight = submenu.scrollHeight + "px";
                    if (subsubmenu != null) {
                        console.log(subsubmenu.scrollHeight)
                        subsubmenu.style.maxHeight = (subsubmenu.scrollHeight + submenu.scrollHeight) + "px";
                    }
                } else {
                    removeClass(parent, 'active');
                    submenu.style.maxHeight = "0px";
                    if (subsubmenu != null) {
                        subsubmenu.style.maxHeight = subsubmenu.scrollHeight + "px";
                    }
                }
            }
        }
    }

    // handle a window resizing event
    window.addEventListener("resize", resizeThrottler, false);
    var resizeTimeout;

    function resizeThrottler() {
        // ignore resize events as long as an actualResizeHandler execution is in the queue
        if (!resizeTimeout) {
            resizeTimeout = setTimeout(function () {
                resizeTimeout = null;
                actualResizeHandler();
                navResizeHandler();
                calculateGreyOffset();
                // The actualResizeHandler will execute at a rate of 15fps
            }, 66);
        }
    }

    function actualResizeHandler() {
        // set the offset to the height of the menu
        if (greymenu && topNav) {
            if (768 >= window.innerWidth) {
                greymenuButton.classList.add('visible');
            }
        }
        if (1023 < window.innerWidth) {
            removeClass(document.getElementById('globalNav'), 'active');
            removeClass(document.getElementById('logo'), 'active');
        }

        scroll();
    }

    function navResizeHandler() {
        /* only perform this function
         * if resizing between tablet and desktop views
         */
        var mobile = (window.innerWidth < 768) ? true : false;
        var tablet = (window.innerWidth < 1024 && window.innerWidth >= 768) ? true : false;
        var desktop = (window.innerWidth >= 1024) ? true : false;
        var mainContent = document.getElementById("content");
        if (mobile && mainContent.getAttribute('data-resized') == 'mobile') {
            return;
        }
        if (tablet && mainContent.getAttribute('data-resized') == 'tablet') {
            return;
        }
        if (desktop && mainContent.getAttribute('data-resized') == 'desktop') {
            return;
        }
        if (mobile) {
            mainContent.setAttribute('data-resized', 'mobile');
        } else if (tablet) {
            mainContent.setAttribute('data-resized', 'tablet');
        } else if (desktop) {
            mainContent.setAttribute('data-resized', 'desktop');
        }

        /* Change the max height style of the menu items
         * based on whether the user displayed sub-nav items
         * during mobile view
         */
        // if (menuItems){
        //     for (var i = 0; i < menuItems.length; i++) {
        //         if (!hasClass(curEl, "active")) {
        //             curEl.style.maxHeight = (mobile) ? "0px" : "none";
        //         } else {
        //             curEl.style.maxHeight = (mobile) ? curEl.scrollHeight : "none";
        //         }
        //     }
        // }


    }

    //scroll effect on the header
    var raf = window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        window.oRequestAnimationFrame;

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var lastScrollTop = scrollTop;

    var header = document.getElementsByClassName('header')[0];
    var resourcesNav = document.getElementById("resourcesNav");
    var headerMaxHeight = 100;
    var minimized = document.getElementsByTagName('body')[0].classList.contains('minimized');

    // grab all initial subnavs
    var subNavs = document.querySelectorAll('.mainNav > .menu-item > .subNav');
    // grab top menu(for calc'ing the top of subnavs)
    var topMenu = document.querySelector('.mainNav');
    // topNav (container for all menu options that appear in top grey menu, below blue banner)
    // topNav = document.querySelector('#topNav');

    var scroll = function () {
        if (!header || minimized) return;

        //note that these sizes are also defined in the CSS and must match.
        headerMaxHeight = 100;
        var windowwidth = window.innerWidth;
        var windowheight = window.innerHeight;
        // by default (mobile), we assume we'll need to resize the resource menu
        var resourceResize = true;
        if (windowwidth >= 1024 && windowwidth < 1150) {
            headerMaxHeight = 130;
            resourceResize = false;
        } else if (windowwidth >= 1150) {
            headerMaxHeight = 140;
            resourceResize = false;
        }
        var size = headerMaxHeight - lastScrollTop;
        if (size <= 0) {
            size = 0;
            header.classList.add("minimized");
        } else if (header.classList.contains("minimized")) {
            header.classList.remove("minimized");
        }
        header.style.height = size + "px";
        // handle resource menu resize at mobile resolution
        if (resourceResize) {
            var resSize = (size > 60) ? windowheight - size : windowheight - 59;
            if (adminbar) {
                resSize = (window.innerWidth < 780) ? resSize - 46 : resSize - 32;
            }
            if( resourcesNav ){
                resourcesNav.style.height = resSize + 'px';
            }
        } else {
            if( resourcesNav ){
                resourcesNav.style.removeProperty('height');
            }
        }

        // with header given new height, we can apply padding rule to topNav
        // if (topNav) {
        //     if (windowwidth < 768) {
        //         topNav.style.paddingBottom = (size > 60) ? (size + 60) + "px" : "120px";
        //     } else {
        //         topNav.style.paddingBottom = "";
        //     }
        // }

        if (subNavs.length > 0) {
            for (var i = 0; i < subNavs.length; i++) {
                subNavs[i].style.top = (topMenu.getBoundingClientRect().bottom - 2) + "px";
            }
        }

        if (greymenu) {
            if (bluebar.getBoundingClientRect().top == parseInt( window.getComputedStyle(bluebar, null).top )) {
                greymenuButton.classList.add('visible');
            } else {
                // greymenu.classList.remove('active');
                // greymenuButton.classList.remove('active');
                greymenuButton.classList.remove('visible');
            }

        }

    };
    scroll();
    if (raf) {
        loop();
    }

    function loop() {
        var scrollTop = scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (lastScrollTop === scrollTop) {
            raf(loop);
            return;
        } else {
            lastScrollTop = scrollTop;

            // fire scroll function if scrolls vertically
            scroll();
            raf(loop);
        }
    }

    //toggle the main menu
    var menuButton = d.getElementById("logo");
    var menu = d.getElementById("globalNav");
    if (menuButton) {
        menuButton.onclick = function (event) {
            if (window.innerWidth < breakpoint) {
                event.preventDefault ? event.preventDefault() : (event.returnValue = false);

                //set the resoures nav as inactive
                removeClass(resources, active);
                removeClass(resourcesButton, active);

                //toggle the main menu
                toggleClass(menu, active);
                toggleClass(menuButton, active);

                return false;
            }
        };
    }
    if (menu) {
        var liarray = menu.querySelectorAll("nav > ul > li");
        var veil = d.getElementById("headerMenuVeil");

        for (var index = 0; index < liarray.length; index++) {
            var element = liarray[index];

            if (element.querySelector(".subNav")) {
                if (element.addEventListener) { // For all major browsers, except IE 8 and earlier
                    element.addEventListener("mouseover", showveil);
                    element.addEventListener("mouseout", hideveil);
                } else if (element.attachEvent) { // For IE 8 and earlier versions
                    element.attachEvent("mouseover", showveil);
                    element.attachEvent("mouseout", hideveil);
                }
            }
        }
    }

    function showveil() {
        addClass(veil, active);
    }

    function hideveil() {
        removeClass(veil, active);
    }

    //toggle the resources menu
    var resourcesButton = d.getElementById("resourcesButton");
    var resources = d.getElementById("resources");
    if (resourcesButton) {
        resourcesButton.onclick = function () {
            //set the main nav as inactive
            removeClass(menu, active);
            removeClass(menuButton, active);

            //hide the search
            removeClass(search, active);
            searchInput.blur();

            //toggle the resource nav
            toggleClass(resources, active);
            toggleClass(resourcesButton, active);
        };
    }

    //toggle the search when the display is over 1024px wide
    var searchButton = d.getElementById("searchButton");
    var searchInput = d.getElementById("searchInput");
    var search = d.getElementById("siteSearch");
    var searchFocusing = false;

    function showSearch(event) {
        event.preventDefault ? event.preventDefault() : event.returnValue = !1;
        if (event.timeStamp < searchFocusing + 250) return false;

        searchFocusing = event.timeStamp;

        var width = window.innerWidth || d.documentElement.clientWidth || d.body.clientWidth;

        if (width >= breakpoint) {
            if (hasClass(search, active)) {
                //search is active, close the form
                removeClass(search, active);

            } else {
                //search is inactive, open the form

                //set the resources nav as inactive
                removeClass(menu, active);
                removeClass(menuButton, active);

                //toggle the resource nav
                addClass(search, active);

                searchInput.focus();
            }
        }

        return false;
    }
    if (searchButton) {
        searchInput.addEventListener("focus", showSearch);
        searchInput.addEventListener("blur", function (event) {
            searchFocusing = event.timeStamp;
            removeClass(search, active);
        });
        searchButton.addEventListener("click", showSearch);
    }

    //toggle the page menu on mobile & get its height
    var pageNavButton = d.getElementById("pageNavButton");
    var pageNav = d.getElementById("pageNav");
    var nbWrapper = d.getElementById("navbarWrapper");

    // try to grab the height of the elem
    if (nbWrapper && pageNavButton) {
        var nbWrapperClone = nbWrapper.cloneNode(true);
        nbWrapperClone.style.visibility = "hidden";
        nbWrapperClone.style.maxHeight = "100%";

        nbWrapper.parentElement.appendChild(nbWrapperClone);

        nbWrapper.setAttribute("data-height", nbWrapperClone.clientHeight);
        nbWrapper.parentElement.removeChild(nbWrapperClone);

        //toggle the resources menu
        pageNavButton.onclick = function () {
            toggleClass(nbWrapper, active);
            toggleClass(pageNavButton, active);
            nbWrapper.style.maxHeight = 0;
            if (hasClass(nbWrapper, active)) {
                nbWrapper.style.maxHeight = nbWrapper.getAttribute('data-height') + "px";
            }
        };

    }

    // catch any hits to links that should be passed to google analytics.
    var hbrun = false; // tracker has not yet run
    var hblink = false;

    /* HitCallback to open link in same window after tracker */
    var hitBack = function () {
        /* run once only */
        if (hbrun) return;
        hbrun = true;
        window.location.href = hblink;
    };

    function findparentlink(el) {
        if (el.tagName == "A") {
            return el.href;
        } else {
            return findparentlink(el.parentElement);
        }
    }

    function trackClick(event) {
        //if (event.target == "")
        var label = this.getAttribute('data-track-label');
        var category = this.getAttribute('data-track-category');
        if (category === undefined) category = 'Static';

        hblink = findparentlink(event.target);
        if (hblink.match(/\/\#/g) != null) {
            return;
        }

        var args = {
            'eventCategory': category, //required
            'eventAction': 'click', //required
            'eventLabel': label,
            'hitCallback': hitBack,
            'hitCallbackFail': hitBack
        };


        if (window.ga) {
            //window.ga('send', 'event', args);
            var trackerName = window.ga.getAll()[0].get('name');
            window.ga(trackerName + '.send', 'event', args);

            //setTimeout(hitBack, 1000); // if GA fails go to the link after a short delay

            event.preventDefault ? event.preventDefault() : event.returnValue = !1;
            return false;
        }
    }

    var atags = d.querySelectorAll("a.track");

    for (var aindex = 0; aindex < atags.length; aindex++) {
        if (atags[aindex].addEventListener) { // For all major browsers, except IE 8 and earlier
            atags[aindex].addEventListener("click", trackClick);
        } else if (atags[aindex].attachEvent) { // For IE 8 and earlier versions
            atags[aindex].attachEvent("click", trackClick);
        }
    }

    document.addEventListener("DOMContentLoaded", function (event) {
        document.body.classList.add('loaded');
        var styles = document.querySelectorAll("link[data-href]");
        for (var index = 0; index < styles.length; index++) {
            styles[index].setAttribute('href', styles[index].getAttribute('data-href'));
            styles[index].removeAttribute('data-href');
        }
    }, false);


    /*
    // Service worker to cache assets
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('service-worker.js', {
        });
    }
    */


    // micropolyfill for browsers that dont support css grid.
    function browserCanUseCssVariables() {
        return window.CSS && window.CSS.supports && window.CSS.supports('display', 'grid');
    }

    /*
    function currentStyleOf(element) {
        var style = element.cascadedStyle || element.specifiedStyle || element.currentStyle || getComputedStyle(element); // TODO: check CSSOM spec for real name
        if (!style.parentElement) {
            style.parentElement = element;
        }
        return style;
    }
    */

    if (!browserCanUseCssVariables()) {

        var gridpolyfill = document.createElement('script');
        gridpolyfill.type = 'text/javascript';
        if (typeof themeURI !== 'undefined') {
            gridpolyfill.src = themeURI + '/dist/scripts/css-grid-polyfill.js';
        } else {
            gridpolyfill.src = '../dist/scripts/css-grid-polyfill.js';
        }
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(gridpolyfill, s);

    }


    // load the menu images when the mouse approaches it.
    var distance;

    function calculateDistance(elem, mouseX, mouseY) {
        var dx = Math.max(elem.offsetLeft - mouseX, 0, mouseX - (elem.offsetLeft + elem.offsetWidth));
        var dy = Math.max(elem.offsetTop - mouseY, 0, mouseY - (elem.offsetTop + elem.offsetHeight));
        return Math.sqrt(dx * dx + dy * dy);
    }

    function checkMenuDistance(e) {

        distance = calculateDistance(menu, e.pageX, e.pageY);

        if (distance < 30) {
            menu.classList.add('show');
            d.removeEventListener('mousemove', checkMenuDistance);
        }

    }

    if (menu) {
        d.addEventListener('mousemove', checkMenuDistance);
    }

    // interact with the alert dialog when active
    var modal = document.getElementById('alert-modal');

    function setclosed() {
        for (var c = 0; c < modal.children.length; c++) {
            setCookie(modal.children[c].id, "closed", 1);
        }
    }

    if (modal) {
        var show = document.getElementById('alert-show');
        var close = document.getElementById('alert-close');


        dialogPolyfill.registerDialog(modal);
        show.addEventListener('click', function () {
            modal.showModal();
        });

        close.addEventListener('click', function () {
            modal.close('cancelled');
            setclosed();
        });

        modal.addEventListener('cancel', function () {
            modal.close('cancelled');
            setclosed();
        });

        // close when clicking on backdrop
        modal.addEventListener('click', function (event) {
            if (event.target === modal) {
                modal.close('cancelled');
                setclosed();
            }
        });

        for (var c = 0; c < modal.children.length; c++) {
            if (!getCookie(modal.children[c].id)) {
                modal.showModal();
            }
        }
    }

    function anchorLinkOffset() {
        if (location.hash.length != 0) {
            var hash = location.hash.slice(1);
            // get the header height
            var header = document.getElementsByClassName('header')[0];
            var headerHeight = header.offsetHeight;
            // if there's a blue navbar, account for that, too.
            var blueNav = document.getElementById('entryHeader');
            if (!blueNav) {
                blueNav = document.getElementById('blueHeader');
            }
            var blueNavHeight = 0;
            if (blueNav) {
                blueNavHeight = blueNav.offsetHeight;
            }
            var el = document.getElementById(hash);
            if (!el) {
                el = document.getElementsByName(hash)[0];
            }
            if (!el) {
                return;
            }
            // scroll down
            el.scrollIntoView();
            // offset
            var scrolled = window.pageYOffset;
            if (scrolled > 0) {
                window.scroll(0, scrolled - (headerHeight + blueNavHeight + 10));
            }
        }
    }
    if (location.hash.length != 0) {
        window.setTimeout(anchorLinkOffset, 10);
    }
    // window.addEventListener('hashchange', function () {
    //     anchorLinkOffset();
    // })

    function anchorLinks(anchorLinks) {
        for (var i = 0; i < anchorLinks.length; i++) {
            anchorLinks[i].addEventListener("click", function (e) {
                e.preventDefault();
                var theId = e.currentTarget.attributes.href.value.replace("#", "");
                // if it's an empty pound sign, scroll to the top and return
                if (theId == "") {
                    window.scroll(0, 0);
                    // get href
                    var href = window.location.href.replace(/\#(.+)/g, "");
                    // change address in bar
                    window.history.pushState({
                        "part": ""
                    }, theId, href + "#");
                } else {
                    // scroll down
                    var href = window.location.href.replace(/\#(.+)/g, "");
                    // change address in bar
                    window.history.pushState({
                        "part": theId
                    }, theId, href + "#" + theId);
                    anchorLinkOffset();
                }
            });
        }
    }
    // any link with # that's not an accordion link, enable anchor
    anchorLinks(document.querySelectorAll('a[href^="#"]:not(.skipnav)'));

    // IE11 Fix: flickity slider event listener for CSS grid polyfill activation
    document.addEventListener('gridactivate', function () {
        if (typeof Flickity === "undefined") {
            return;
        }
        var slidersInGrids = document.querySelectorAll('.grid .carousel');
        for (var i = 0; i < slidersInGrids.length; i++) {
            var flkty = Flickity.data(slidersInGrids[i]);
            flkty.resize();
        }
    });

    // give some object fit love to IE
    if (is_ieedge()) {
        //object fit
        injectscript( themeURI + '/dist/scripts/ofi.min.js', function () {
            objectFitImages(false, {
                watchMQ: true,
                skipTest: true
            });
        });
    }


    // load the typekit tracking css
    window.addEventListener("load",function(event) {
        var css = document.createElement("link");
        css.rel = 'stylesheet';
        css.media = 'all';
        css.href = "https://p.typekit.net/p.css?s=1&k=bkb5yfb&ht=tk&f=139.171.175.13378.13380&a=706986&app=typekit&e=css";
        document.body.appendChild(css);
    }, false);


    // check to see if we should offer a page translation. 
    var userlang = (navigator.languages) ? navigator.languages[0] : (navigator.language || navigator.userLanguage);
    userlang = userlang.substring(0, 2);
    if( "en" !== userlang ){
        injectscript( 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');
    }

}(document, "active", 1024));

function googleTranslateElementInit() {
    new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element');
}